import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Illustration from '../../Illustration';

import avatar from '@material-ui/core/colors/grey';

import {
  CardList,
  CardListItem,
  ColumnItem,
} from '../../core';

import {
  selectWorkTypesList,
} from '../../../store/selectors';

const styles = theme => ({
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
});

const WorkTypeCards = ({ classes, workTypes, handleSelect }) => {
  return (
    <CardList handleSelect={handleSelect}>
      {workTypes.length > 0 &&
        workTypes.map((workType, i) => {
          return (
            <CardListItem key={i} item={workType} handleSelect={handleSelect}>
              <ColumnItem>
                <Avatar className={classes.avatar}>
                  W
                </Avatar>
              </ColumnItem>
              <ColumnItem>
                <Typography noWrap variant="subheading">
                  {workType.name}
                </Typography>
                <Typography noWrap variant="caption">
                  {`$${workType.rate}`}
                </Typography>
              </ColumnItem>
            </CardListItem>
          );
        })
      }
      {workTypes.length === 0 &&
        <Illustration
          title="Hmm, no Work Types..."
          imgKey="QA_engineers_amber"
          explainerText="Do you charge clients by the hour sometimes? Define each type of work and your rate for each, you’ll see the magic happen when entering a Time Card!"
          addItemText="Let’s get them entered by clicking the “Floating Action Button” at top right."
        />
      }
    </CardList>
  );
};

const mapStateToProps = (state) => ({
  workTypes: selectWorkTypesList(state),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(WorkTypeCards);



// WEBPACK FOOTER //
// ./src/components/admin/WorkTypes/WorkTypeCards.jsx